import { createContext, useCallback, useEffect, useState } from "react";
import {
  getDistrictData,
  getDSOList,
  getStateData,
  getDsoAdminCategory,
} from "../services/adminApiService/dsoAPIs/dsoApis";

export const DSOContext = createContext();

export const DSOProvider = ({ children }) => {
  const [showCreateDSO, setShowCreateDSO] = useState(false);
  const [adminCategoryTypeList, setAdminCategoryTypeList] = useState([]);

  const setShowCreateModal = () => setShowCreateDSO(true);
  const handleClose = () => {
    setEditData(null);
    setShowCreateDSO(false);
    setFormData({});
    setErrors({});
  };
  
  const [loading, setIsLoading] = useState(false);
  const [statesList, setStatesList] = useState([]);
  const [districtList, setDistrictList] = useState([]);
  const [DSOList, setDSOList] = useState([]);
  const [errors, setErrors] = useState({});
  const [editData, setEditData] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    password: "",
    state: "",
    district: "",
  });
  // Fetch states
  const fetchStates = useCallback(async () => {
    try {
      const res = await getStateData(101);
      setStatesList(res.data || []);
    } catch (error) {
      console.error("Error fetching states:", error);
    }
  }, []);

  // Fetch districts when state changes
  const fetchDistricts = useCallback(async (stateId) => {
    try {
      if (!stateId) return;
      const res = await getDistrictData(stateId);
      setDistrictList(res.data || []);
    } catch (error) {
      console.error("Error fetching districts:", error);
    }
  }, []);


  const fetchAdminCategoryTypes = useCallback(async () => {
    // alert("dddd");
    try {
      const res = await getDsoAdminCategory();
      setAdminCategoryTypeList(res.data || []);
    } catch (error) {
      console.error("Error fetching admin category type:", error);
    }
  }, []);

  const fetchDSOs = useCallback(async (sort_by, order_by,perPage,currentPage) => {
    try {
      setIsLoading(true);
      console.log(sort_by, order_by);
      const res = await getDSOList(sort_by, order_by,perPage, currentPage);
      setDSOList(res.data || []);
    } catch (error) {
      console.error("Error fetching DSO List:", error);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchDSOs();
  }, [fetchDSOs]);

  useEffect(() => {
    fetchStates();
  }, [fetchStates]);

  useEffect(() => {
    fetchDistricts(formData.state);
  }, [formData.state, fetchDistricts]);

  useEffect(() => {
    if (editData) {
      setFormData({
        name: editData.name || "",
        phone: editData.phone || "",
        email: editData.email || "",
        password: editData.org_pwd || "",
        state: editData.state_id || "",
        district: editData.district_id || "",
        adminCateogry: editData.category_id || "", 
      });
    } else {
      setFormData({});
    }
  }, [editData]);

  return (
    <DSOContext.Provider
      value={{
        loading,
        setIsLoading,
        statesList,
        districtList,
        errors,
        setErrors,
        setFormData,
        formData,
        DSOList,
        fetchDSOs,
        showCreateDSO,
        setShowCreateModal,
        handleClose,
        editData,
        setEditData,
        fetchAdminCategoryTypes,
        adminCategoryTypeList, 
      }}
    >
      {children}
    </DSOContext.Provider>
  );
};
